export default __webpack_public_path__ + "static/media/purse-1.9db56267.png";